import Button from '@rio-cloud/rio-uikit/Button';
import ButtonGroup from '@rio-cloud/rio-uikit/ButtonGroup';
import { useLocation, useNavigate } from 'react-router';

import { routes } from '../../routes/routes';
import { G, useGraphLabel } from '../graph/shared/messages';

export default function VariantNavigation() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const label = useGraphLabel();
    const graph = pathname.startsWith(routes.GRAPH);
    return (
        <nav className='display-flex align-items-center gap-10' aria-label={label('variant')}>
            <span className='hidden-xs text-color-dark text-size-12'>
                <G name='variant' />
            </span>
            <ButtonGroup>
                <Button bsSize='sm' active={!graph} aria-pressed={!graph} onClick={() => navigate(routes.DEFAULT)}>
                    <G name='original' />
                </Button>
                <Button bsSize='sm' active={graph} aria-pressed={graph} onClick={() => navigate(routes.GRAPH)}>
                    <G name='graph' />
                </Button>
            </ButtonGroup>
        </nav>
    );
}
